require('./scss/main.scss');
require('./js/app.js');

/* function requireAll(r) {
	r.keys().forEach(r);
}

require.context('icons/', true);
// require.context('svg/', true); */